import React, { useEffect } from 'react'
import { NavButton } from '../../Elements'
import { Icon } from '@blueprintjs/core'
import { primaryTheme } from '../../utils/helpers'

const hasUnreadStyles = {
    textAlign: 'center',
    verticalAlign: 'center',
    marginLeft: '-5px',
    paddingTop: '2px',
    marginTop: '-15px',
    fontSize: '8pt',
    backgroundColor: primaryTheme,
    borderRadius: '15%',
    color: 'white',
    width: '20px',
    height: '15px',
    alignContent: 'center',
}

const noUnreadStyles = {
    visibility: 'hidden'
}

const errorOrLoadingStyles = {
    ...hasUnreadStyles,
    marginLeft: '-10px',
    backgroundColor: 'white',
}

export const NotificationsBadge = ({ loading, error, data, setNotifications, setNotificationsDialogIsOpen }) => {
    const notifications = data?.notifications
    useEffect(() => {
        if (!loading && !error && setNotifications) setNotifications(notifications)
    }, [loading, error, setNotifications, notifications])

    if (loading) {
        return (
            <NavButton text='' icon='notifications' style={{ textAlign: 'center' }} >
                <div style={errorOrLoadingStyles}>
                    <Icon icon='cloud-download'></Icon>
                </div>
            </NavButton>
        )
    }

    if (error) {
        return (
            <NavButton text='' icon='notifications' style={{ textAlign: 'center' }} >
                <div style={errorOrLoadingStyles}>
                    <Icon icon='issue'></Icon>
                </div>
            </NavButton>
        )
    }

    const unreadNotifications = data.notifications.filter(n => !n.is_read)
    const unreadCount = unreadNotifications.length

    return (
        <NavButton text='' icon='notifications' style={{ textAlign: 'center' }} onClick={() => setNotificationsDialogIsOpen(true)} >
            <div style={unreadCount > 0 ? hasUnreadStyles : noUnreadStyles}>
                <b>{unreadCount > 0
                    ? unreadCount
                    : ''
                }</b>
            </div>
        </NavButton>
    )
}
